import { render, staticRenderFns } from "./NurseList.vue?vue&type=template&id=60390d57&scoped=true&"
import script from "./NurseList.vue?vue&type=script&lang=js&"
export * from "./NurseList.vue?vue&type=script&lang=js&"
import style0 from "./NurseList.vue?vue&type=style&index=0&id=60390d57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60390d57",
  null
  
)

export default component.exports